import React, { useState, useEffect } from "react";
import { Message } from "./components";
import useMediaDevices from "./hooks/use-media-devices";
import { I18n, translate } from "@td/shared_utils";

const VideoCapabilities = ({ consultationId }) => {
  if (!window.FEATURE_TOGGLES["video_capabilities_alert"]) {
    return null;
  }

  const {
    loading,
    hasWebcam,
    hasSpeakers,
    hasMicrophone,
    hasWebcamAcccess, 
    hasMicrophoneAcccess,
  } = useMediaDevices();

  const currentUserAgent = window.navigator.userAgent;
  const videoCapabilities = JSON.parse(window.localStorage.getItem("videoCapabilities"));
  const [approvedUserAgent, setApprovedUserAgent] = useState(
    videoCapabilities && videoCapabilities.approvedUserAgent
  );

  useEffect(() => {
    window.navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });
  }, []);

  useEffect(() => {
    const eventHandler = () => {
      setApprovedUserAgent(currentUserAgent);
    };

    window.jQuery(document).on("ADLTEST:passed", eventHandler);
  
    return () => {
      window.jQuery(document).off("ADLTEST:passed", eventHandler);
    };
  }, []);

  useEffect(() => {
    window.localStorage.setItem("videoCapabilities", JSON.stringify({
      ...videoCapabilities,
      approvedUserAgent,
    }))
  }, [approvedUserAgent]);

  if (!loading && (!hasWebcam || !hasSpeakers || !hasMicrophone)) {
    return (
      <Message
        consultationId={consultationId}
        value={
          <React.Fragment>
            <p data-testid="video-capabilities-device-unplugged-list-title">
              <I18n scope="video_capabilities.device_unplugged" text="list_title" />
            </p>
            <ul data-testid="video-capabilities-device-unplugged-devices-list">
              {!hasWebcam && <li><I18n scope="video_capabilities.devices" text="webcam" /></li>}
              {!hasSpeakers && <li><I18n scope="video_capabilities.devices" text="speakers" /></li>}
              {!hasMicrophone && <li><I18n scope="video_capabilities.devices" text="microphone" /></li>}
            </ul>
            <p data-testid="video-capabilities-device-unplugged-advice">
              <I18n scope="video_capabilities.device_unplugged" text="advice" />
            </p>
          </React.Fragment>
        }
      />
    );
  }

  if (!loading && (!hasWebcamAcccess || !hasMicrophoneAcccess)) {
    return (
      <Message
        consultationId={consultationId}
        value={
          <React.Fragment>
            <p data-testid="video-capabilities-device-blocked-list-title">
              <I18n scope="video_capabilities.device_blocked" text="list_title" />
            </p>
            <ul data-testid="video-capabilities-device-blocked-devices-list">
              {!hasWebcamAcccess && <li><I18n scope="video_capabilities.devices" text="webcam" /></li>}
              {!hasMicrophoneAcccess && <li><I18n scope="video_capabilities.devices" text="microphone" /></li>}
            </ul>
            <p data-testid="video-capabilities-device-blocked-advice">
              <I18n scope="video_capabilities.device_blocked" text="advice" />
            </p>
          </React.Fragment>
        }
      />
    );
  }

  if (window.FEATURE_TOGGLES["video_capabilities_alert"]["update_checking"]) {
    if (approvedUserAgent === null) {
      return (
        <Message
          consultationId={consultationId}
          value={translate(null, "video_capabilities", "not_tested_before")}
        />
      );
    }

    if (approvedUserAgent !== currentUserAgent) {
      return (
        <Message
          consultationId={consultationId}
          value={translate(null, "video_capabilities", "software_updated")}
        />
      );
    }
  }

  return null;
};

export default VideoCapabilities;
